import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_TRADEPLUS_URL;
export const recordAppDownload = async (data) => {
  const response = await axios.post(
    `${API_BASE_URL}/AppDownloads`,
    {
      platform: "pwa",
      appVersion: data?.appVersion ?? null,
      source: data?.source ?? "direct",
    }
  );

  return response.data;
};